import { showToast } from "../utils/toast";

let bound = false;

export function initStagesModal(): void {
  if (bound) return;
  bound = true;
  document.addEventListener("click", async (event) => {
    const button = (event.target as HTMLElement).closest<HTMLButtonElement>("[data-pl-edit-stages]");
    if (!button?.dataset.plEditStages) return;
    event.preventDefault();
    const host = button.closest<HTMLElement>(".camp-refresh") || document.body;
    button.disabled = true;
    try {
      const response = await fetch(button.dataset.plEditStages, { headers: { Accept: "text/html" }, credentials: "same-origin" });
      if (!response.ok) throw new Error(String(response.status));
      host.querySelector(".pl-modal-wrap")?.remove();
      host.insertAdjacentHTML("beforeend", await response.text());
    } catch {
      showToast("Couldn't open the stages. Try again.", "error", 3000);
    } finally {
      button.disabled = false;
    }
  });
}
